import type { ArchbaseRemoteApiClient } from '@archbase/data';
import { injectable, inject } from 'inversify';
import { ARCHBASE_IOC_API_TYPE } from '@archbase/core';
import type { OptimizeRequest } from '@domain/optimization/OptimizeTypes';
import type { OptimizeResponse } from '@domain/routeJob/RouteJobDto';

@injectable()
export class RouteXOptimizationService {
  constructor(@inject(ARCHBASE_IOC_API_TYPE.ApiClient) private client: ArchbaseRemoteApiClient) {}

  async optimizeSync(request: OptimizeRequest): Promise<OptimizeResponse> {
    return this.client.post('/api/v1/routes/optimize/sync', request);
  }

  async optimizeAsync(request: OptimizeRequest): Promise<{ id: string; status: string }> {
    return this.client.post('/api/v1/routes/optimize', request);
  }
}
